/* eslint-disable no-undef */
// @flow
import * as React from 'react'
import StatsBadge from '../../shared/Header/StatsBadge'

type Props = {
  model: Object,
  statsToDisplay: Array<Object>
}

export default class DashboardHeaderBottom extends React.Component<Props> {
  static defaultProps = {
    statsToDisplay: [
      {
        key: 'total_complexity_issues',
        label: 'complexity issues',
        format: '0'
      }, {
        key: 'total_duplications',
        label: 'duplications',
        format: '0'
      }, {
        key: 'total_lint_issues',
        label: 'style issues',
        format: '0'
      }, {
        key: 'total_lines_of_code',
        label: 'lines of code',
        format: '0'
      }, {
        key: 'total_duplications',
        label: 'duplications',
        format: '0'
      }, {
        key: 'total_coverage',
        label: 'code coverage',
        format: '0%'
      }
    ]
  }

  render () {
    return (
      <div style={{verticalAlign: 'top'}}>
        {this.props.statsToDisplay.map((stat) => {
          const value = this.props.model.attributes[stat.key]
          if (stat.key === 'total_lint_issues' && (value === null || value === 0)) {

          } else {
            return <StatsBadge {...stat} value={value} />
          }
        }
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/Header/DashboardHeaderBottom.js